import { UserRole } from '@/features/users/constants'
import useUser from '@/features/users/useUser'
import { isNullish } from '@/utils/helper'
import { useNavigate, useSearchParams } from 'react-router-dom'
import UserForm from '../components/UserForm'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { useDispatch } from 'react-redux'

const AddUser = () => {
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type') || UserRole.ADMIN
  const vendorId = searchParams.get('vendorId') || ''
  const { useCreateUser } = useUser()
  const dispatch = useDispatch()

  const newUser = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    role: type === UserRole.VENDOR ? UserRole.VENDOR : '',
    departments: [],
  }

  if (!isNullish(vendorId)) {
    newUser.supplier = vendorId
  }

  const createUser = useCreateUser()
  const navigate = useNavigate()

  const onSubmit = async (data) => {
    try {
      dispatch(showLoadingOverlay())
      const res = await createUser.mutateAsync(data)
      navigate(type === UserRole.VENDOR ? '/admin/users/vendors' : '/admin/users/')
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }

  return <UserForm onSubmitAction={onSubmit} user={newUser} type={type} isCreate={true} />
}

export default AddUser
